import 'babel-polyfill';

import '@/utils/disableConsole';

import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App.vue';
import router from './router';
import store from './store';
import Logger from './plugin/VueLoggerPlugin';
import Layout from './plugin/VueLayoutPlugin';
import Viewport from './plugin/VueViewportPlugin';
import Moment from './plugin/VueMomentPlugin';
import i18n from './lang/_i18n';
import VueTour from 'vue-tour';
import { VuejsDatatableFactory } from 'vuejs-datatable';
import VueDOMPurifyHTML from 'vue-dompurify-html';

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import AudioVisual from 'vue-audio-visual';
import mdiVue from 'mdi-vue';
import * as mdijs from '@mdi/js';
import _ from 'lodash';
import VueApollo from 'vue-apollo';
import { apolloProvider } from './modules/GraphQL';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faExclamationCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

locale.el.pagination.pagesize = '';

Vue.use(AudioVisual);
Vue.use(Logger);
Vue.use(Layout);
Vue.use(Viewport, { store });
Vue.use(Moment);
Vue.use(ElementUI, { locale });
Vue.use(PerfectScrollbar);
Vue.use(VuejsDatatableFactory);
Vue.use(VueTour);
Vue.use(mdiVue, { icons: mdijs });
Vue.use(VueApollo);
Vue.set(Vue.prototype, '$_', _);
Vue.use(VueDOMPurifyHTML, {
  hooks: {
    afterSanitizeAttributes: (node) => {
      if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
      }
    }
  }
});

require('@/assets/css/reset.css');
require('@/assets/css/main.css');
require('@/assets/css/main_sp.css');
require('@/assets/css/header_sp.css');
require('@/assets/css/utility.css');
require('vue-tour/dist/vue-tour.css');
require('@/assets/css/libs/font-awesome.css');

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App)
}).$mount('#app');
